// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.TripEtaPopup .CloseButton {
  color: var(--bs-white);
}
.TripEtaPopup .popover-body {
  position: relative;
  overflow: hidden;
  padding: 0;
  border-radius: calc(var(--bs-popover-border-radius) - 1px);
}
.TripEtaPopup .popover-body h5 {
  margin: 0 2rem 0 0;
  padding: 0.3rem;
  width: 100%;
  background-color: var(--bs-black);
  color: var(--bs-white);
}
.TripEtaPopup .popover-body p {
  margin: 0;
  font-size: 1.2rem;
  padding: 0.6rem;
}`, "",{"version":3,"sources":["webpack://./src/features/Trips/components/TripEtaPopup/styles.scss"],"names":[],"mappings":"AACE;EACE,sBAAA;AAAJ;AAEE;EACE,kBAAA;EACA,gBAAA;EACA,UAAA;EACA,0DAAA;AAAJ;AAEI;EACE,kBAAA;EACA,eAAA;EACA,WAAA;EACA,iCAAA;EACA,sBAAA;AAAN;AAEI;EACE,SAAA;EACA,iBAAA;EACA,eAAA;AAAN","sourcesContent":[".TripEtaPopup {\n  .CloseButton {\n    color: var(--bs-white);\n  }\n  .popover-body {\n    position: relative;\n    overflow: hidden;\n    padding: 0;\n    border-radius: calc(var(--bs-popover-border-radius) - 1px);\n\n    h5 {\n      margin: 0 2rem 0 0;\n      padding: 0.3rem;\n      width: 100%;\n      background-color: var(--bs-black);\n      color: var(--bs-white);\n    }\n    p {\n      margin: 0;\n      font-size: 1.2rem;\n      padding: 0.6rem;\n    }\n  }\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
